import React from "react";

import Header from "components/Header/Header.js";

import HeaderLinks from "components/Header/HeaderLinks.js";
import useStyles from "../styles/styles";

import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import { colors } from "components/Theme/WebTheme.js";
import VideoBg from "components/VideoBg.js";
import BottomFooter from "components/Footer/BottomFooter.js";
import { Grid, Typography, Box } from "@mui/material";
import { FONT_FAMILY } from "common/sharedFunctions";
const dashboardRoutes = [];

export default function ContactUs(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;
  const settings = useSelector((state) => state.settingsdata.settings);
  return (
    <div style={{ margin: "-8px" }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <VideoBg />

      <Box className={classes.centerContainer}>
        <Grid container spacing={3} className={classes.aboutUsContainer}>
          <Grid item xs={12} md={12} style={{ position: "relative" }}>
            <Typography
              variant="h4"
              fontWeight={700}
              fontFamily={FONT_FAMILY}
              className={classes.homeTitle}
            >
              {t("contact_us")}
            </Typography>
            <div
              style={{
                margin: "0px auto",
                display: "flex",
                justifyContent: "center",
                color: "white",
                maxWidth: "60%",
              }}
            >
              <p
                className={
                  isRTL === "rtl"
                    ? classes.rtlDescription
                    : classes.ltrDescription
                }
              >
                {settings.CompanyName} <br />
                {settings && settings.CompanyPhone ? (
                  <p
                    className={
                      isRTL === "rtl"
                        ? classes.rtlDescription
                        : classes.ltrDescription
                    }
                  >
                    {t("phone")}: {settings.CompanyPhone}
                  </p>
                ) : null}
                <p
                  className={
                    isRTL === "rtl"
                      ? classes.rtlDescription
                      : classes.ltrDescription
                  }
                ></p>
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>

      <BottomFooter />
    </div>
  );
}
